import { cn } from '@/lib/utils/cn';

interface BrandMarkProps {
  collapsed?: boolean;
  /** `inverse` for dark surfaces (login brand panel). */
  tone?: 'default' | 'inverse';
  className?: string;
}

/** SORAI symbol: rounded frame with code chevrons and a sparkle. Inherits `currentColor`. */
export function SoraiSymbol({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={cn('shrink-0', className)}
    >
      <path
        d="M26 6H8a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V16"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M17 13.5 11.5 19l5.5 5.5M19.5 20.5 25 26l-5.5 5.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 0c.6 3.6 1.4 4.4 5 5-3.6.6-4.4 1.4-5 5-.6-3.6-1.4-4.4-5-5 3.6-.6 4.4-1.4 5-5Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** SORAI logo (symbol + wordmark) with the ERP product tag. */
export function BrandMark({ collapsed = false, tone = 'default', className }: BrandMarkProps) {
  const color = tone === 'inverse' ? 'text-inverse-strong' : 'text-brand';
  if (collapsed) {
    return (
      <span role="img" className={cn('flex', color, className)} aria-label="SORAI ERP">
        <SoraiSymbol className="size-8" />
      </span>
    );
  }
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <SoraiSymbol className={cn('size-8', color)} />
      <span className="flex items-baseline gap-1.5">
        <span className={cn('text-[1.375rem] leading-none font-medium tracking-tight', color)}>
          Sorai
        </span>
        <span
          className={cn(
            'text-[0.6875rem] font-medium tracking-wider uppercase',
            tone === 'inverse' ? 'text-inverse-muted' : 'text-subtle-foreground',
          )}
        >
          ERP
        </span>
      </span>
    </span>
  );
}
